import { render } from "./suggestion.vue?vue&type=template&id=28d0c690"
import script from "./suggestion.vue?vue&type=script&lang=js"
export * from "./suggestion.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__